import styled from 'styled-components';

export const Wrapper = styled.div`
  .ant-collapse-header {
    align-items: center !important;
  }
`;
